import api from './axios';
import { Recipe } from '../types';

export const recipesApi = {
  getAll: () => api.get<Recipe[]>('/recipes'),

  getById: (id: number) => api.get<Recipe>(`/recipes/${id}`),

  create: (data: Partial<Recipe>) => api.post<Recipe>('/recipes', data),

  update: (id: number, data: Partial<Recipe>) =>
    api.put<Recipe>(`/recipes/${id}`, data),

  delete: (id: number) => api.delete(`/recipes/${id}`),

  sell: (id: number, quantity?: number) =>
    api.post(`/recipes/${id}/sell`, { quantity: quantity || 1 }),
};
